export const NAME_MASK_CONFIG = {
  tokens: {
    '@': {
      pattern: /[a-zA-Z\s' -]/,
      transform: (value: string) => value.replace(/\s{2,}/g, ' '),
      repeated: true,
    },
  },
  mask: '@',
}

export const PASSPORT_MASK_CONFIG = {
  tokens: {
    '@': {
      pattern: /[0-9a-zA-Z]/,
      repeated: true,
      transform: (chr: string) => chr.toUpperCase(),
    },
  },
  mask: '@',
}

export const ID_MASK_CONFIG = {
  tokens: {
    '#': {
      pattern: /[0-9]/,
      repeated: true,
    },
  },
  mask: '#',
}

export const PASSPORT_MAX_LENGTH = 20
export const ID_MAX_LENGTH = 11
export const DEFAULT_MAX_LENGTH = 60

export const DEFAULT_DATE_MASK = 'd MMM yyyy'
export const DEFAULT_DATE_MASK_AR = 'd MMMM yyyy'
